import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import Pile from '../Pile';
import { Button, ButtonRow, Muted } from '../Controls';

/**
 * Pick exactly `selectCount` cards from a pile, then hand their ids to `onSelectDone` in the order they were picked.
 * With `numbered`, each chosen card shows its place in that order (Pokédex).
 */
const SelectPile = ({
  selectCount, onSelectDone, selectedIds: initialSelectedIds, message, cardsOrCardables, doneLabel, numbered, newestFirst,
}) => {
  const [selectedIds, updateSelectedIds] = useState(initialSelectedIds);
  const allChosen = selectCount === selectedIds.size;

  const getSelectButton = useCallback((card) => {
    const id = card.get('pivot_id');

    if (selectedIds.includes(id)) {
      return <Button $primary onClick={() => updateSelectedIds(selectedIds.filterNot(selected => selected === id))}>
        {numbered ? `#${selectedIds.indexOf(id) + 1}` : 'Chosen'}
      </Button>;
    }

    return <Button onClick={() => updateSelectedIds(selectedIds.push(id))} disabled={allChosen}>Choose</Button>;
  }, [selectedIds, allChosen, numbered]);

  const getDim = useCallback(
    (card) => allChosen && !selectedIds.includes(card.get('pivot_id')),
    [allChosen, selectedIds]
  );

  return (
    <>
      <p>{message}</p>
      <Pile cardsOrCardables={cardsOrCardables} getDim={getDim} getSelectButton={getSelectButton} newestFirst={newestFirst} />
      <ButtonRow style={{ marginTop: 16 }}>
        <Muted>{selectedIds.size} of {selectCount} chosen</Muted>
        <Button $primary disabled={!allChosen} onClick={() => onSelectDone(selectedIds)}>{doneLabel || 'Done'}</Button>
      </ButtonRow>
    </>
  );
};

SelectPile.propTypes = {
  cardsOrCardables: PropTypes.instanceOf(List).isRequired,
  message: PropTypes.string.isRequired,
  selectedIds: PropTypes.instanceOf(List).isRequired,
  selectCount: PropTypes.number.isRequired,
  onSelectDone: PropTypes.func.isRequired,
  /** What the finishing button says, when it does more than finish choosing ("Attack"). */
  doneLabel: PropTypes.string,
  numbered: PropTypes.bool,
  /** Highest position first: the newest discard, or the top of the deck. */
  newestFirst: PropTypes.bool,
};

export default SelectPile;
